import { createSlice } from '@reduxjs/toolkit'

export const onLoadProgramReducer = (state, { payload }) => {
  const { program } = payload

  const newState = {
    ...state,
    program
  }
  return newState
}

export const onProgramUpdatedReducer = (state, { payload }) => {
  const { canvasProgram } = payload

  const newState = {
    ...state,
    canvasProgram
  }
  return newState
}

export const onLoadMyProgramsReducer = (state, { payload }) => {
  const { myPrograms } = payload

  const newState = {
    ...state,
    myPrograms
  }

  return newState
}

export const updateTitleReducer = (state, { payload }) => {
  const title = payload

  const newState = {
    ...state,
    program: {
      ...state.program,
      title
    }
  }

  return newState
}

export const updateDescriptionReducer = (state, { payload }) => {
  const description = payload

  const newState = {
    ...state,
    program: {
      ...state.program,
      description
    }
  }

  return newState
}

export const updateTagsReducer = (state, { payload }) => {
  const tags = payload

  const newState = {
    ...state,
    program: {
      ...state.program,
      tagList: tags.toString()
    }
  }

  return newState
}

export const setProgramDetailOpenReducer = (state, { payload }) => {
  const programDetailOpen = payload

  const newState = {
    ...state,
    programDetailOpen
  }

  return newState
}

export const setEditDetailsOpenReducer = (state, { payload }) => {
  const editDetailsOpen = payload

  const newState = {
    ...state,
    editDetailsOpen
  }
  return newState
}

export const setCopyModalOpenReducer = (state, { payload }) => {
  const copyModalOpen = payload

  const newState = {
    ...state,
    copyModalOpen
  }
  return newState
}

export const setFilterOpenReducer = (state, { payload }) => {
  const filterOpen = payload

  const newState = {
    ...state,
    filterOpen
  }
  return newState
}

export const clearProgramReducer = (state) => {
  const newState = {
    ...state,
    canvasProgram: {}
  }
  return newState
}

export const updateFilterReducer = (state, { payload }) => {
  const newState = {
    ...state,
    filterOption: payload
  }

  return newState
}

export const deleteProgramReducer = (state) => {
  const newState = {
    ...state,
    program: {
      id: null,
      title: '',
      slug: '',
      description: '',
      createdAt: null,
      images: [],
      videos: [],
      robots: [],
      user: {},
      code: '',
      programType: 'block',
      tagList: ''
    }
  }

  return newState
}

const dashboardSlice = createSlice({
  name: 'program',
  initialState: {
    program: {
      id: null,
      title: '',
      slug: '',
      description: '',
      createdAt: null,
      images: [],
      videos: [],
      robots: [],
      user: {},
      code: '',
      programType: 'block',
      tagList: ''
    },
    canvasProgram: {
      identifier: '',
      name: '',
      data: '',
      program_type: 'block',
      robots: null
    },
    filterOption: {
      selectedRobots: [],
      tags: [],
      programType: '',
      sortOption: '',
      text: ''
    },
    filterOpen: false,
    myPrograms: [],
    programDetailOpen: false,
    editDetailsOpen: false
  },
  reducers: {
    onLoadProgram: onLoadProgramReducer,
    onLoadMyPrograms: onLoadMyProgramsReducer,
    setProgramDetailOpen: setProgramDetailOpenReducer,
    setEditDetailsOpen: setEditDetailsOpenReducer,
    setCopyModalOpen: setCopyModalOpenReducer,
    clearProgram: clearProgramReducer,
    deleteProgram: deleteProgramReducer,
    onProgramUpdated: onProgramUpdatedReducer,
    updateTitle: updateTitleReducer,
    updateDescription: updateDescriptionReducer,
    updateTags: updateTagsReducer,
    onFilterOpen: setFilterOpenReducer,
    updateFilter: updateFilterReducer
  }
})

const { actions, reducer } = dashboardSlice

export const {
  onLoadProgram,
  onLoadMyPrograms,
  setProgramDetailOpen,
  setEditDetailsOpen,
  clearProgram,
  deleteProgram,
  onProgramUpdated,
  updateTitle,
  updateDescription,
  updateTags,
  updateFilter,
  setCopyModalOpen,
  onFilterOpen
} = actions

export default reducer
